// extracted by mini-css-extract-plugin
module.exports = {"container":"LockBadge_container__2hvAj"};